(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('ci-cart-upsell')) {
  customElements.define('ci-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.ci-upsell-track');
      const prev = this.querySelector('[data-ci-prev]');
      const next = this.querySelector('[data-ci-next]');
      if (!track || !prev || !next) return;
      const positions = () => {
        const left = track.getBoundingClientRect().left;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        return [...track.children].map(card => Math.max(0, Math.min(max, card.getBoundingClientRect().left - left + track.scrollLeft)));
      };
      const closest = () => positions().reduce((best, pos, i, all) => Math.abs(pos - track.scrollLeft) < Math.abs(all[best] - track.scrollLeft) ? i : best, 0);
      const update = () => {
        const counter = this.querySelector('[data-ci-slide]');
        if (counter) counter.textContent = (closest() + 1) + ' / ' + track.children.length;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      let target = null;
      for (const [button, direction] of [[prev, -1], [next, 1]]) {
        button.addEventListener('click', event => {
          event.stopPropagation();
          target = Math.max(0, Math.min(track.children.length - 1, (target ?? closest()) + direction));
          track.scrollTo({left: positions()[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal});
      }
      for (const type of ['touchstart', 'touchmove', 'pointerdown']) {
        track.addEventListener(type, event => { event.stopPropagation(); target = null; }, {passive: true, signal});
      }
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('scrollend', () => { target = null; update(); }, {signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); (event.key === 'ArrowRight' ? next : prev).click();
        }
      }, {signal});
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
if (!customElements.get('ci-cart-summary')) {
  customElements.define('ci-cart-summary', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.version = 0;
      this.total = Number(this.dataset.total);
      this.shipping = null;
      this.currency = this.dataset.currency || 'BRL';
      this.root = window.Shopify?.routes?.root || '/';
      this.money = cents => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: this.currency}).format(cents / 100);
      this.zip = this.querySelector('[data-ci-zip]');
      this.button = this.querySelector('[data-ci-calculate]');
      this.status = this.querySelector('[data-ci-status]');
      this.rates = this.querySelector('[data-ci-rates]');
      this.paint();
      if (!this.zip) return;
      try {
        const saved = JSON.parse(sessionStorage.getItem('ci-shipping-address') || 'null');
        if (saved) { this.zip.value = saved.zip || ''; }
      } catch (_) {}
      this.button.addEventListener('click', () => this.calculate(), {signal: this.abort.signal});
      for (const field of [this.zip]) {
        field.addEventListener('input', () => this.invalidate(), {signal: this.abort.signal});
        field.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); this.calculate(); }
        }, {signal: this.abort.signal});
      }
      this.zip.addEventListener('input', () => {
        const digits = this.zip.value.replace(/\D/g, '').slice(0, 8);
        this.zip.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
      }, {signal: this.abort.signal});
      document.addEventListener('cart:change', () => this.invalidate(), {signal: this.abort.signal});
      if (this.zip.value.replace(/\D/g, '').length === 8) this.calculate();
    }
    disconnectedCallback() { this.version++; this.abort?.abort(); this.request?.abort(); }
    invalidate() {
      this.version++;
      this.request?.abort();
      this.shipping = null;
      this.rates?.replaceChildren();
      if (this.status) this.status.textContent = '';
      if (this.button) { this.button.disabled = false; this.button.textContent = 'Calcular'; }
      this.paint();
    }
    paint() {
      const total = this.total + (this.shipping ?? 0);
      const set = (selector, value) => { const el = this.querySelector(selector); if (el) el.textContent = value; };
      set('[data-ci-total]', this.money(total));
      const pixTotal = Math.round(total * .95);
      set('[data-ci-pix]', this.money(pixTotal));
      set('[data-ci-pix-saving]', this.money(total - pixTotal));
      set('[data-ci-installment]', this.money(Math.round(total / (Number(this.dataset.installments) || 6))));
      set('[data-ci-shipping-price]', this.dataset.shipping !== 'true' ? 'Não se aplica' : this.shipping === null ? 'A calcular' : this.shipping === 0 ? 'Grátis' : this.money(this.shipping));
      set('[data-ci-total-note]', this.dataset.shipping !== 'true' ? '' : this.shipping === null ? 'Sem frete até calcular o CEP.' : 'Inclui o frete estimado. Confirmação no checkout.');
    }
    deliveryLabel(rate) {
      const text = [rate.name, rate.presentment_name, rate.description].filter(value => typeof value === 'string').join(' ');
      const explicit = text.match(/(?:até\s+)?\d+\s*(?:(?:a|à|até|[-–])\s*\d+\s*)?dias?\s*[úu]teis/i);
      if (explicit) return 'Prazo: ' + explicit[0];
      const raw = Array.isArray(rate.delivery_days) ? rate.delivery_days : [rate.delivery_days];
      const days = raw.filter(value => value !== null && value !== undefined && value !== '' && /^\d+$/.test(String(value))).map(Number);
      if (days.length) {
        const min = Math.min(...days), max = Math.max(...days);
        return 'Prazo: ' + (min === max ? max : min + ' a ' + max) + (max === 1 ? ' dia útil' : ' dias úteis');
      }
      return 'Prazo não informado pela transportadora; consulte no checkout.';
    }
    async calculate() {
      if (this.button.disabled) return;
      this.invalidate();
      const zip = this.zip.value.replace(/\D/g, '');
      if (zip.length !== 8) {
        this.status.textContent = 'Informe um CEP válido de 8 dígitos.';
        this.zip.focus();
        return;
      }
      const version = this.version;
      this.request = new AbortController();
      const request = this.request;
      const timeout = setTimeout(() => request.abort(), 25000);
      const signal = this.request.signal;
      this.button.disabled = true;
      this.button.textContent = 'Calculando…';
      this.status.textContent = 'Consultando as opções de entrega…';
      try {
        try { sessionStorage.setItem('ci-shipping-address', JSON.stringify({zip: this.zip.value})); } catch (_) {}
        const addressResponse = await fetch('https://viacep.com.br/ws/' + zip + '/json/', {signal, credentials: 'omit'});
        if (!addressResponse.ok) throw new Error('Não foi possível consultar o CEP. Tente novamente.');
        const address = await addressResponse.json();
        if (address.erro || !/^[A-Z]{2}$/.test(address.uf || '')) throw new Error('CEP não encontrado. Confira os números informados.');
        const params = new URLSearchParams({'shipping_address[zip]': zip, 'shipping_address[country]': 'Brazil', 'shipping_address[province]': address.uf});
        const prepared = await fetch(this.root + 'cart/prepare_shipping_rates.json?' + params, {method: 'POST', signal, credentials: 'same-origin'});
        if (!prepared.ok) throw new Error('Não foi possível cotar. Confira o CEP ou consulte no checkout.');
        let data = null;
        for (let attempt = 0; attempt < 16; attempt++) {
          await new Promise(resolve => setTimeout(resolve, attempt ? 1000 : 400));
          if (signal.aborted) throw new Error('A consulta demorou mais que o esperado. Tente novamente.');
          const response = await fetch(this.root + 'cart/async_shipping_rates.json?' + params, {signal, credentials: 'same-origin', cache: 'no-store'});
          if (!response.ok) throw new Error('Não foi possível consultar o frete agora. Tente novamente ou continue ao checkout.');
          data = await response.json();
          if (data !== null) break;
        }
        if (!this.isConnected || version !== this.version) return;
        if (!data) throw new Error('A consulta demorou mais que o esperado. Tente novamente.');
        const rates = (data.shipping_rates || []).filter(rate => Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0 && (!rate.currency || rate.currency === this.currency)).sort((a, b) => Number(a.price) - Number(b.price));
        if (!rates.length) throw new Error('Nenhuma opção retornada para este CEP. Confira o endereço no checkout.');
        rates.forEach((rate, index) => {
          const cents = Math.round(Number(rate.price) * 100);
          const label = document.createElement('label'); label.className = 'ci-rate';
          const input = document.createElement('input'); input.type = 'radio'; input.name = 'ci-shipping-estimate'; input.checked = index === 0;
          const name = document.createElement('span'); name.textContent = rate.name || 'Entrega';
          const deadline = document.createElement('small');
          deadline.className = 'ci-rate-deadline';
          deadline.textContent = this.deliveryLabel(rate);
          name.append(deadline);
          const price = document.createElement('strong'); price.textContent = cents === 0 ? 'Grátis' : this.money(cents);
          input.addEventListener('change', () => { this.shipping = cents; this.paint(); }, {signal: this.abort.signal});
          label.append(input, name, price); this.rates.append(label);
        });
        this.shipping = Math.round(Number(rates[0].price) * 100);
        this.paint();
        this.status.textContent = 'Selecione a entrega desejada:';
      } catch (error) {
        if (this.isConnected && version === this.version) this.status.textContent = error.name === 'AbortError' ? 'A consulta demorou mais que o esperado. Tente novamente.' : error.message;
      } finally {
        clearTimeout(timeout);
        if (this.isConnected && version === this.version) { this.button.disabled = false; this.button.textContent = 'Calcular'; }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
